'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = require('react-transition-group/TransitionGroup');

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = require('./Transition');

var _Transition2 = _interopRequireDefault(_Transition);

require('./default.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Animated = function Animated(_ref) {
  var disabled = _ref.disabled,
      items = _ref.items,
      props = _objectWithoutProperties(_ref, ['disabled', 'items']);

  if (disabled) return props.children;

  if (items) return _react2.default.createElement(
    _TransitionGroup2.default,
    null,
    props.children
  );

  var enter = props.enter,
      exit = props.exit,
      preset = props.preset,
      timeout = props.timeout;

  // avoid mutating params

  var propsCopy = props;

  // default animation is fadeIn/fadeOut
  if (!preset && !(enter || exit)) {
    propsCopy.preset = 'react-animated-transitions-fade';
    propsCopy.timeout = 400;
  }

  // if only animate on enter
  if (enter && !exit) propsCopy.timeout = {
    enter: timeout,
    exit: 0
  };

  // if only animate on exit
  if (!enter && exit) propsCopy.timeout = {
    enter: 0,
    exit: timeout
  };

  return _react2.default.createElement(_Transition2.default, propsCopy);
};

Animated.propTypes = {
  children: _propTypes2.default.any.isRequired,
  disabled: _propTypes2.default.bool,
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  item: _propTypes2.default.bool,
  items: _propTypes2.default.bool,
  preset: _propTypes2.default.string,
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
};

Animated.defaultProps = {
  disabled: false,
  enter: undefined,
  exit: undefined,
  item: false,
  items: false,
  preset: undefined,
  timeout: 1000
};

exports.default = Animated;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-animated-transitions/dist/Animated.js
// module id = 148
// module chunks = 0